<template>
    <div class="content-box">
        <el-row :gutter="20">
            <el-col :span="12" v-if="deny_list.length>0">
                <div class="data-list deny-list">
                    <h4 class="title-group text-normal font12px mb10 clearfix">
                        <span class="text-color-error fl">无权限账户（数量：{{deny_list.length}}）</span>
                        <span class="text-color-primary pointer fr" @click="copyId">一键复制ID</span>
                    </h4>
                    <ul class="list-wrap">
                        <li v-for="item in deny_list" :key="item.account_id">{{item.account_name||'-'}}（{{item.account_id}}）</li>
                    </ul>
                </div>
            </el-col>
            <el-col :span="12">
                <div class="data-list allow-list">
                    <h4 class="title-group text-normal font12px mb10">
                        <span>有权限账户（数量：{{allow_list.length}}）</span>
                    </h4>
                    <ul class="list-wrap">
                        <li v-for="item in allow_list" :key="item.account_id">{{item.account_name||'-'}}（{{item.account_id}}）</li>
                    </ul>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "DetailInfoModal",
        props:{
            data:Object,
        },
        data(){
            return {
                // allow_list:[],
                // deny_list:[],
            };
        },
        computed:{
            allow_list(){
                return this.data.allow_list||[];
            },
            deny_list(){
                return this.data.deny_list||[];
            },
        },
        methods:{
            copyId(){
                console.log('copyId');
                let result = this.deny_list.map(item=>item.account_id).join('\r\n');
                if (!navigator.clipboard) {
                    let ele = document.createElement("input");
                    ele.value = result;
                    document.body.appendChild(ele);
                    ele.select();
                    document.execCommand("copy");
                    document.body.removeChild(ele);
                    if (document.execCommand("copy")) {
                        console.log("复制成功1！");
                        this.$message.success('复制成功');
                    } else {
                        console.log("复制失败1！");
                    }
                } else {
                    navigator.clipboard.writeText(result).then(()=> {
                        console.log("复制成功2！");
                        this.$message.success('复制成功');
                    }).catch(function () {
                        console.log("复制失败2！");
                    })
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .data-list{
        padding: 10px;
        /*min-height: 200px;*/
        /*max-height: 500px;*/
        &.deny-list{
            border: solid 1px #dfdfdf;
            background-color: #fafafa;
        }
        &.allow-list{
            border: solid 1px #d0effc;
            background-color: #eef9fe;
        }

        .list-wrap{
            padding-left: 6px;
            height: 300px;
            overflow-y: auto;
            li{
                line-height: 20px;
                font-size: 12px;
            }
        }
    }
</style>
